import { render, staticRenderFns } from "./SidebarButton.vue?vue&type=template&id=797349ed&"
import script from "./SidebarButton.vue?vue&type=script&lang=js&"
export * from "./SidebarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports